import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {Preview} from 'asax-common';
import {AsaxPropertiesService} from 'asax-properties';

@Component({
  selector: 'asax-result-table-cell-preview',
  templateUrl: './cell-preview.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CellPreviewComponent {
  @Input() preview: Preview;
  @Input() thumbnailFile: string;

  @Output() outCartaFile = new EventEmitter<string>();

  previewHeight = 210;
  previewWidth = 350;

  constructor(public readonly asaxPropertiesService: AsaxPropertiesService) {
  }

  openFileInANewTab(file: string): void {
    const dataPortalUrl = this.asaxPropertiesService.getProperties().dataPortalUrl;
    window.open(`${dataPortalUrl}/${file}`, '_blank');
  }

  emitOpenCarta() {
    this.outCartaFile.emit(this.preview.fitsFile);
  }
}
